import axios from "axios";
import {getApiUrls} from "@/http/base.http";
const { btoa } = require('abab');

export const attemptLogin = credentials => new Promise((resolve, reject) => {
    const { env } = getApiUrls();
    axios({url: `${env}login`, data: credentials, method: 'POST' })
        .then(resp => {

                const accessToken = resp.data.token
                sessionStorage.setItem('accessToken', btoa(accessToken))
                sessionStorage.setItem('user', JSON.stringify(resp.data));
                axios.defaults.headers.common['Authorization'] = accessToken
                resolve(resp)
        })
        .catch(err => {
            // delete axios.defaults.headers.common['Authorization']
            sessionStorage.removeItem('accessToken') // if the request fails, remove any possible user token if possible
            reject(err)
        })
});

